const initYoutubePlayer = () => {
  const buttons = [...document.querySelectorAll('[data-youtube-play]')]
  if (!buttons.length) return

  const setupPlayers = () => {
    buttons.forEach((btn) => {
      const iframeId = btn.getAttribute('data-youtube-play')
      const overlays = [...document.querySelectorAll(`[data-youtube-overlay="${iframeId}"]`)]

      const player = new YT.Player(iframeId, {
        events: {
          onStateChange: ({ data }) => {
            if (data === YT.PlayerState.PLAYING) {
              btn.classList.add('hidden')
              overlays.forEach(el => el.classList.add('hidden'))
            } else if (data === YT.PlayerState.PAUSED || data === YT.PlayerState.ENDED) {
              btn.classList.remove('hidden')
              overlays.forEach(el => el.classList.remove('hidden'))
            }
          }
        }
      })

      btn.addEventListener('click', () => {
        player.playVideo()
        btn.classList.add('hidden')
        overlays.forEach(el => el.classList.add('hidden'))
      })
    })
  }

  if (window.YT && window.YT.Player) {
    setupPlayers()
  } else {
    window.onYouTubeIframeAPIReady = setupPlayers
    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    document.head.appendChild(tag)
  }
}

export default initYoutubePlayer
